/*
  Chip.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Icons.
import DeleteIcon from '../../icons/Close';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    verticalAlign: 'middle',
    userSelect: 'none',
    overflow: 'hidden',
    borderRadius: '32px',
    height: 30,
    minWidth: 30,
    lineHeight: 1,
    padding: theme.space(0.5, 1.5),
    color: theme.color_text_primary,
    backgroundColor: theme.color_divider,
    fontSize: '0.875rem',
    '&.outlined': {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.color_text_disabled}`,
    },
    '&.small': {
      fontSize: '0.8rem',
      height: 27,
      minWidth: 27,
      '& > button > .SvgIcon': {
        fontSize: '16px',
      }
    },
    '&.clickable': {
      cursor: 'pointer',
    },
    '& > .iconContainer': {
      paddingRight: theme.space(1),
    },
    '& > .label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: '1.4',
    },
    '& > button': {
      marginLeft: theme.space(0.5),
      marginRight: theme.space(-0.5),
      color: theme.color_text_disabled,
      cursor: 'pointer',
      padding: 0,
      background: 'none',
      border: 'none',
      display: 'inline-flex',
      '& > .SvgIcon': {
        fontSize: '18px',
      }
    },
    '&.disabled': {
      opacity: 0.6,
    },
  },
}));

/**
 * Chip component.
 */
export default function Chip({
  className,
  label,
  size,
  variant,
  onDelete,
  onClick,
  disabled,
  icon = null,
  onMouseDownDelete,
  ...rest
}) {

  let rootClass = 'Chip';

  if (size === 'small') {
    rootClass += ' small';
  }

  if (variant === 'outlined') {
    rootClass += ' outlined';
  }

  if (typeof onClick === 'function' && !disabled) {
    rootClass += ' clickable';
  }

  if (disabled) {
    rootClass += ' disabled';
  }

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  return (
    <div className={cls} title={label} onClick={!disabled ? onClick : undefined} {...rest}>
      {
        icon != null &&
        <span className="iconContainer">{ icon }</span>
      }
      <span className="label">{ label }</span>
      {
        // TODO: Later make this an actual button.
        typeof onDelete === 'function' && !disabled &&
        <button
          type="button"
          onClick={onDelete}
          onMouseDown={onMouseDownDelete}
        >
          <DeleteIcon />
        </button>
      }
    </div>
  );
}
